import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import TargetedUntargetedCustodianSelector from 'components/pages/manage/forms/edit_audience/targeted_untargeted_selector/TargetedUntargetedCustodianSelector';
import { AudienceType, UntargetedStaffAudienceProps, UntargetedStudentAudienceProps, StaffAudienceProps, StudentAudienceProps, ParentAudienceProps, UntargetedParentAudienceProps } from '../../../../../models/FormProps';
import TargetedUntargetedStudentSelector from './TargetedUntargetedStudentSelector';
import TargetedUntargetedStaffSelector from './TargetedUntargetedStaffSelector';

interface Props {
  viewableAudience:
  | StaffAudienceProps
  | StudentAudienceProps
  | UntargetedStudentAudienceProps
  | UntargetedStaffAudienceProps
  | ParentAudienceProps
  | UntargetedParentAudienceProps;
  viewOnly: boolean;
  updateViewableAudienceCallback: (updated:
  | StaffAudienceProps
  | StudentAudienceProps
  | UntargetedStudentAudienceProps
  | UntargetedStaffAudienceProps
  | ParentAudienceProps
  | UntargetedParentAudienceProps) => void;
  formHasResponses: boolean;
  expectedAudience?: AudienceType;
}

export default function TargetedUntargetedSelector(props: Props): React.ReactElement {
  const { viewableAudience, viewOnly, updateViewableAudienceCallback, formHasResponses, expectedAudience } = props;
  const renderSelectorForAudience = () => {
    switch (viewableAudience.type) {
      case AudienceType.STAFF:
      case AudienceType.UNTARGETED_STAFF:
        return (
          <TargetedUntargetedStaffSelector
            viewableAudience={viewableAudience}
            viewOnly={viewOnly}
            updateViewableAudienceCallback={updateViewableAudienceCallback}
            formHasResponses={formHasResponses}
            expectedAudience={expectedAudience}
          />
        );
      case AudienceType.STUDENT:
      case AudienceType.UNTARGETED_STUDENT:
        return (
          <TargetedUntargetedStudentSelector
            viewableAudience={viewableAudience}
            viewOnly={viewOnly}
            updateViewableAudienceCallback={updateViewableAudienceCallback}
            formHasResponses={formHasResponses}
            expectedAudience={expectedAudience}
          />
        );
      default:
        return (
          <TargetedUntargetedCustodianSelector
            viewableAudience={viewableAudience}
            viewOnly={viewOnly}
            updateViewableAudienceCallback={updateViewableAudienceCallback}
            formHasResponses={formHasResponses}
            expectedAudience={expectedAudience}
          />
        );
    }
  };

  return (
    <Stack spacing={1}>
      <Typography variant="h5" textAlign="center" fontWeight="bold" color="primary.main">
        Choose who can respond
      </Typography>
      {renderSelectorForAudience()}
    </Stack>
  );
}
